export enum ContentType {
  post = 1,
  comment,
}

export enum AssetsTimeInterval {
  '7d' = 1,
  '1m',
  '3m',
  'all',
}

export enum OptionsTimeInterval {
  '1h' = 1,
  '6h',
  '1d',
  '1w',
  'all',
}

export enum OrderSide {
  deposit = 1,
  withdraw,
}

export enum SearchType {
  all = 0,
  market,
  user,
}

export enum MarketStatus {
  progress = 1,
  settlement,
  disputed,
  closed,
}

// Event-level status (from backend EventStatus enum)
export enum EventStatus {
  active = 1,
  resolved,
  voided,
  frozen,
}

export enum PositionStatus {
  using = 1,
  winOption,
  loseOption,
}

export enum FollowStatus {
  yes = 1,
  no,
}

export enum LikeStatus {
  yes = 1,
  no,
}

export enum MarketsSortType {
  createTime = 1,
  volume,
  participants,
  old,
  recommend,
  expireTime,
}

export enum ClaimStatus {
  yes = 1,
  no,
}

export enum NotificationCategory {
  transaction = 1,
  mention,
}

export enum NotificationStatus {
  read = 1,
  unread,
}

export enum NotificationType {
  initialPoints = 1,
  claimTask,
  transaction,
  marketSettlement,
  comment = 6,
  like,
  follow,
  invited,
}

export enum TransactionType {
  buy = 1,
  sell,
  claimMarket,
  initPoints,
  invitePoints,
  deposit,
  withdraw,
  claimTask,
}

export enum CommentType {
  root = 1,
  reply,
}

export enum TransactionStatus {
  success = 1,
  fail,
  pending,
}

export enum BannerType {
  Section,
  Market,
  External,
  Event,
}
export enum SectionType {
  Normal,
  Colorful,
}

export enum TaskType {
  once = 1,
  daily = 2,
}

export enum TaskTxStatus {
  success = 1,
  fail = 2,
  pending = 3,
}

export enum TimeInterval {
  day = 1,
  week,
  month,
  all,
}

export enum LeaderboardSortType {
  pnl = 1,
  volume,
  tradeCount,
  overall,
}

export enum ApiErrorCode {
  ErrNameTooLong = 42001,
  ErrDescTooLong = 42002,
  ErrInvalidInviteCode = 42003,
  ErrDuplicateAddress = 42004,
  ErrDuplicateEmail = 42005,
  ErrUserNotFound = 42006,
  ErrRepeatFollowOrUnfollow = 42007,
  ErrCanNotFollowSelf = 42008,
  ErrMustFollowUserFirst = 42009,
  ErrMarkOtherNotification = 42010,
  ErrInvalidNotificationUUIDs = 42011,
  ErrPostTitleTooLong = 43001,
  ErrPostContentTooLong = 43002,
  ErrCommentContentTooLong = 43003,
  ErrPostEmpty = 43004,
  ErrCommentEmpty = 43005,
  ErrPostNotFound = 43006,
  ErrCommentNotFound = 43007,
  ErrRepeatLikeOrUnlike = 43008,
  ErrMustLikeFirst = 43009,
  ErrMarketNotFound = 44001,
  ErrDuplicatedFollowMarket = 44002,
  ErrMustFollowMarketFirst = 44003,
  ErrInvalidUserOperation = 45001,
  ErrInvalidAlchemy = 45002,
  ErrParam = 10001,
  ErrWait = 10003,
  ErrNotFound = 10004,
  ErrInternal = 50001,
  ErrNetwork = 50002,
  ErrAlchemy = 60001,
  ErrS3 = 60002,
  ErrBindInviteCodeRepeatedly = 42012,
  ErrBindSelfInviteCode = 101113,
  ErrMutualInviteCode = 42014,
  ErrInviteCodeMustBefore = 42015,
}
